// Catálogo único de ferramentas do web administrativo (/v2). Consumido pela sidebar desktop e pelo menu mobile.
import { useMemo } from 'react';
import {
  LayoutDashboard, Activity, Users, GraduationCap, Wallet,
  MessageSquare, BrainCircuit, Rocket, ShieldCheck, Settings,
  AlertTriangle, Zap, DoorOpen, Bell, ClipboardList, UserCircle,
  FileText, BookOpen, Calendar, BarChart3, Receipt, CreditCard, ListChecks,
  Building2, Layers, ArrowLeftRight, Banknote, PieChart, Scale,
  TrendingUp, Megaphone, Target, Share2, MessageCircle, Sparkles,
  Import, Shield, Bus, ShieldAlert, AlertCircle,
  Clock, Star, ScrollText, Printer, FileSignature, Archive
} from 'lucide-react';
import { usePermissoes } from '../lib/permissoes';
import { usePermV2 } from '../lib/perm_v2';

export const navSections = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/v2/dashboard', glow: '#8E52AB',
    children: [
      { label: 'Painel Global', path: '/v2/dashboard', icon: LayoutDashboard },
      { label: 'Executivo', path: '/v2/financeiro/executivo', icon: TrendingUp },
      { label: 'Alertas', path: '/v2/central', icon: AlertTriangle },
    ] },
  { id: 'operacao', label: 'Operação', icon: Activity, path: '/v2/central', badge: 'pendencias', glow: '#F59E0B',
    children: [
      { label: 'Central Operacional', path: '/v2/central', icon: ClipboardList },
      { label: 'Lembretes', path: '/v2/comunicacao/lembretes', icon: Bell },
      { divider: true, label: 'DNA GO' },
      { label: 'Painel de Saída', path: '/v2/operacao/painel', icon: DoorOpen },
      { label: 'Portaria', path: '/v2/operacao/portaria', icon: ShieldAlert },
      { label: 'Autorizados', path: '/v2/operacao/autorizados', icon: Shield },
      { label: 'Retiradas', path: '/v2/operacao/retiradas', icon: Users },
      { label: 'Vans', path: '/v2/operacao/vans', icon: Bus },
      { label: 'Ocorrências', path: '/v2/operacao/ocorrencias', icon: AlertCircle },
    ],
    more: [
      { label: 'Painel DNA GO', path: '/v2/operacao', icon: DoorOpen },
    ] },
  { id: 'alunos', label: 'Alunos', icon: Users, path: '/v2/aluno', glow: '#8E52AB',
    children: [
      { label: 'Aluno 360', path: '/v2/aluno', icon: UserCircle },
      { label: 'Matrículas e Rematrículas', path: '/v2/matriculas', icon: ClipboardList },
      { label: 'Painel Operacional', path: '/v2/matriculas/painel', icon: ClipboardList },
      { label: 'Central de Documentação', path: '/v2/matriculas/documentos', icon: FileText },
      { label: 'Virada de Ano', path: '/v2/matriculas/virada-ano', icon: ClipboardList },
      { label: 'DNA Chat', path: '/v2/chat', icon: MessageSquare },
      { label: 'Carteirinhas', path: '/v2/academico/carteirinhas', icon: CreditCard },
      { label: 'Documentos', path: '/v2/academico/documentos', icon: FileText },
    ],
    more: [
      { label: 'Cadastros Incompletos', path: '/v2/alunos/cadastros-incompletos', icon: AlertCircle },
      { label: 'WhatsApp · Configuração', path: '/v2/chat/whatsapp/config', icon: MessageCircle },
      { label: 'WhatsApp · Fila de envio', path: '/v2/chat/whatsapp/queue', icon: MessageCircle },
      { label: 'WhatsApp · Falhas', path: '/v2/chat/whatsapp/failures', icon: MessageCircle },
      { label: 'WhatsApp · Templates', path: '/v2/chat/whatsapp/templates', icon: MessageCircle },
    ] },
  { id: 'secretaria', label: 'Secretaria', icon: ScrollText, path: '/v2/secretaria/historico', glow: '#8E52AB',
    children: [
      { label: 'Novos DNAs', path: '/v2/secretaria/novos-dnas', icon: Sparkles },
      { label: 'Histórico Escolar', path: '/v2/secretaria/historico', icon: ScrollText },
      { label: 'Históricos Gerados', path: '/v2/secretaria/historico/emissoes', icon: FileText },
      { label: 'Fila de Impressão', path: '/semana-avaliacoes/relatorio-impressao', icon: Printer },
    ] },
  { id: 'academico', label: 'Acadêmico', icon: GraduationCap, path: '/v2/academico', glow: '#6366F1',
    children: [
      { label: 'Portal Equipe DNA', path: '/v2/academico/portal-professor', icon: Users },
      { label: 'DNA Mapa', path: '/v2/pedagogico/dna-mapa', icon: Target },
      { label: 'Turmas', path: '/v2/academico/turmas', icon: Users },
      { label: 'Agrupamentos', path: '/v2/academico/agrupamentos', icon: Layers },
      { label: 'Professores', path: '/v2/academico/professores', icon: UserCircle },
      { label: 'Horários', path: '/v2/academico/horarios', icon: Clock },
      { label: 'Avaliações', path: '/v2/academico/avaliacoes', icon: FileText },
      { label: 'Editor de Avaliações', path: '/v2/academico/editor-avaliacoes', icon: FileText },
      { label: 'Notas', path: '/v2/academico/notas', icon: BarChart3 },
      { label: 'Pendências Acadêmicas', path: '/v2/academico/pendencias', icon: AlertCircle },
      { label: 'Boletim', path: '/v2/academico/boletim', icon: BookOpen },
      { label: 'Matrizes', path: '/v2/academico/matrizes', icon: Layers },
      { label: 'Cursos', path: '/v2/academico/cursos', icon: GraduationCap },
      { label: 'Agenda', path: '/v2/academico/agenda', icon: Calendar },
      { label: 'Calendário', path: '/v2/academico/calendario', icon: Calendar },
      { label: 'Carteirinhas', path: '/v2/academico/carteirinhas', icon: CreditCard },
      { label: 'Documentos', path: '/v2/academico/documentos', icon: FileText },
      { divider: true, label: 'RELATÓRIOS' },
      { label: 'Lista de Chamada', path: '/v2/academico/relatorios/lista-chamada', icon: ListChecks },
      { label: 'Livro de Classe Premium', path: '/v2/academico/relatorios/livro-de-classe', icon: BookOpen },
      { divider: true, label: 'EDUCAÇÃO INFANTIL' },
      { label: 'DNA Infantil 360 IA', path: '/v2/infantil', icon: Star },
    ],
    more: [
      { label: 'DNA Estudos', path: '/v2/academico/dna-estudos', icon: BookOpen },
    ] },
  { id: 'financeiro', label: 'Financeiro', icon: Wallet, path: '/v2/financeiro', glow: '#10B981',
    children: [
      { label: 'Visão Geral', path: '/v2/financeiro', icon: PieChart },
      { divider: true, label: 'DNA SIGN' },
      { label: 'DNA Sign', path: '/v2/dna-sign', icon: FileSignature },
      { label: 'Documentos', path: '/v2/dna-sign/documentos', icon: FileText },
      { label: 'Modelos', path: '/v2/dna-sign/modelos', icon: Layers },
      { label: 'Assinatura em Massa', path: '/v2/dna-sign/massa', icon: Users },
      { label: 'Cofre Digital', path: '/v2/dna-sign/cofre', icon: ShieldCheck },
      { divider: true, label: 'DNA PAY' },
      { label: 'Dashboard', path: '/v2/financeiro/dnapay', icon: Banknote, permV2: { module: 'dnapay', verb: 'visualizar' } },
      { label: 'Títulos', path: '/v2/financeiro/dnapay/titulos', icon: Receipt, permV2: { module: 'dnapay', verb: 'visualizar' } },
      { label: 'Saúde Financeira', path: '/v2/financeiro/dnapay/saude', icon: Activity, permV2: { module: 'dnapay', verb: 'visualizar' } },
      { label: 'Declarações de IR', path: '/v2/financeiro/dnapay/declaracao-ir', icon: FileText, permV2: { module: 'dnapay', verb: 'visualizar' } },
      { label: 'Gerar Títulos / Boletos', path: '/v2/financeiro/gerar-titulos', icon: FileText },
      { label: 'Remessas CNAB', path: '/v2/financeiro/dnapay/remessas', icon: ArrowLeftRight },
      { label: 'Retornos CNAB', path: '/v2/financeiro/dnapay/retornos', icon: Import },
      { label: 'Extrato PIX (baixa automática)', path: '/v2/financeiro/dnapay/pix-extrato', icon: Import },
      { label: 'Cobranças Automáticas', path: '/v2/financeiro/cobrancas-auto', icon: Clock },
      { label: 'Importar Títulos', path: '/v2/financeiro/importar', icon: Import },
      { label: 'Importar Boletos Safra', path: '/v2/financeiro/dnapay/importar-boletos', icon: Import, permV2: { module: 'dnapay', verb: 'visualizar' } },
      { label: 'Histórico de Importações', path: '/v2/financeiro/dnapay/importar-boletos/dashboard', icon: Layers, permV2: { module: 'dnapay', verb: 'visualizar' } },
      { label: 'Notificações App', path: '/v2/financeiro/dnapay/notificacoes', icon: Bell, permV2: { module: 'dnapay', verb: 'visualizar' } },
      { label: 'Configurações DNA Pay', path: '/v2/financeiro/config', icon: Layers },
      { divider: true, label: 'PLANOS · CAIXA' },
      { label: 'Planos', path: '/v2/financeiro/planos', icon: Layers },
      { label: 'Planos por Turma', path: '/v2/financeiro/planos-turma', icon: Layers },
      { label: 'Caixa · DRE · IA', path: '/v2/financeiro/dre-caixa-ia', icon: Layers },
      { label: 'Conciliação', path: '/v2/financeiro/conciliacao', icon: ArrowLeftRight },
      { label: 'Contas Bancárias', path: '/v2/financeiro/contas', icon: Building2 },
      { label: 'Despesas', path: '/v2/financeiro/despesas', icon: CreditCard },
      { label: 'Lançamentos', path: '/v2/financeiro/lancamentos', icon: FileText },
      { label: 'DRE', path: '/v2/financeiro/dre', icon: BarChart3 },
      { label: 'Inadimplentes', path: '/v2/financeiro/inadimplentes', icon: AlertTriangle },
      { label: 'Renegociação', path: '/v2/financeiro/renegociacao', icon: ArrowLeftRight },
      { label: 'Central de Recuperação', path: '/v2/financeiro/central-recuperacao', icon: ShieldAlert, permV2: { module: 'cobranca', verb: 'visualizar' } },
      { label: 'Cobrança Extrajudicial', path: '/v2/financeiro/cobranca-extrajudicial', icon: ShieldAlert, permV2: { module: 'cobranca', verb: 'visualizar' } },
      { label: 'Folha Pagamento', path: '/v2/financeiro/folha', icon: Banknote },
      { divider: true, label: 'FISCAL' },
      { label: 'Fiscal / NFS-e', path: '/v2/financeiro/fiscal', icon: Scale },
      { label: 'Tributário', path: '/v2/financeiro/tributario', icon: Scale },
      { divider: true, label: 'EXECUTIVO' },
      { label: 'Painel Executivo', path: '/v2/financeiro/executivo', icon: TrendingUp },
      { label: 'Analytics', path: '/v2/financeiro/analytics', icon: BarChart3 },
      { label: 'Relatórios', path: '/v2/financeiro/relatorios', icon: BarChart3 },
    ],
    more: [
      { label: 'Central de Lançamentos', path: '/v2/financeiro/central-lancamentos', icon: FileText },
      { label: 'Painel de Cobrança', path: '/v2/financeiro/cobranca-dashboard', icon: BarChart3 },
      { label: 'Títulos (tela clássica)', path: '/v2/financeiro/titulos', icon: Receipt },
      { label: 'Mensageria DNA Pay', path: '/v2/financeiro/mensageria', icon: MessageCircle },
      { label: 'Agendador DNA Pay', path: '/v2/financeiro/scheduler', icon: Clock },
      { label: 'Rateio', path: '/v2/financeiro/rateio', icon: PieChart },
      { label: 'Bases de Rateio', path: '/v2/financeiro/bases-rateio', icon: Layers },
      { label: 'Fiscal · Notas emitidas', path: '/v2/financeiro/fiscal/notas', icon: Scale },
      { label: 'Fiscal · Emissão', path: '/v2/financeiro/fiscal/emissao', icon: Scale },
      { label: 'Fiscal · Erros', path: '/v2/financeiro/fiscal/erros', icon: Scale },
      { label: 'Fiscal · Integração', path: '/v2/financeiro/fiscal/integracao', icon: Scale },
      { label: 'Fiscal · Logs', path: '/v2/financeiro/fiscal/logs', icon: Scale },
      { label: 'Fiscal · Relatórios', path: '/v2/financeiro/fiscal/relatorios', icon: Scale },
      { label: 'Fiscal · Configuração', path: '/v2/financeiro/fiscal/config', icon: Scale },
      { label: 'Tributário · Apuração', path: '/v2/financeiro/tributario/apuracao', icon: Scale },
      { label: 'Tributário · Memória de cálculo', path: '/v2/financeiro/tributario/memoria', icon: Scale },
      { label: 'Tributário · Simulações', path: '/v2/financeiro/tributario/simulacoes', icon: Scale },
      { label: 'Tributário · Relatórios', path: '/v2/financeiro/tributario/relatorios', icon: Scale },
      { label: 'Tributário · Configuração', path: '/v2/financeiro/tributario/config', icon: Scale },
      { label: 'Tributário · Logs', path: '/v2/financeiro/tributario/logs', icon: Scale },
      { label: 'Executivo · DRE', path: '/v2/financeiro/executivo/dre', icon: TrendingUp },
      { label: 'Executivo · Previsão', path: '/v2/financeiro/executivo/forecast', icon: TrendingUp },
      { label: 'Executivo · Segmentos', path: '/v2/financeiro/executivo/segmentos', icon: TrendingUp },
    ] },
  { id: 'comunicacao', label: 'Comunicação', icon: MessageSquare, path: '/v2/comunicacao', glow: '#06B6D4',
    children: [
      { label: 'Central', path: '/v2/comunicacao/mensagens', icon: MessageSquare },
      { label: 'Mural', path: '/v2/comunicacao/mural', icon: Megaphone },
      { label: 'Campanhas', path: '/v2/comunicacao/campanhas', icon: Target },
      { label: 'Templates', path: '/v2/comunicacao/templates', icon: FileText },
      { label: 'Alertas', path: '/v2/comunicacao/alertas', icon: AlertCircle },
      { label: 'Aniversariantes', path: '/v2/comunicacao/aniversariantes', icon: Star },
      { divider: true, label: 'EVENTOS' },
      { label: 'Eventos (config)', path: '/v2/festa-junina/eventos', icon: Star, permV2: { module: 'festa_junina', verb: 'configurar' } },
      { label: 'Festa Junina 2026', path: '/v2/festa-junina', icon: Star, permV2: { module: 'festa_junina', verb: 'visualizar' } },
      { label: 'Sorteio', path: '/v2/festa-junina/sorteio', icon: Star, permV2: { module: 'festa_junina', verb: 'visualizar' } },
      { label: 'Check-in (QR)', path: '/v2/festa-junina/checkin', icon: Target, permV2: { module: 'festa_junina', verb: 'visualizar' } },
      { divider: true, label: 'DNA CONNECT' },
      { label: 'Central Admin', path: '/v2/familia/admin', icon: Settings },
      { label: 'Aulas Extras', path: '/v2/familia/aulas-extras', icon: BookOpen },
    ],
    more: [
      { label: 'Festa Junina · Administração', path: '/v2/festa-junina/admin', icon: Star, permV2: { module: 'festa_junina', verb: 'visualizar' } },
      { label: 'Festa Junina · Impressão', path: '/v2/festa-junina/imprimir', icon: Printer, permV2: { module: 'festa_junina', verb: 'visualizar' } },
    ] },
  { id: 'inteligencia', label: 'Inteligência', icon: BrainCircuit, path: '/v2/ia', glow: '#3B82F6',
    children: [
      { label: 'Painel IA', path: '/v2/ia', icon: BrainCircuit },
      { label: 'Assistente IA', path: '/v2/ia/assistente', icon: Sparkles },
      { label: 'Fluência', path: '/v2/ia/fluencia', icon: BrainCircuit },
      { label: 'Tabuada', path: '/v2/ia/tabuada', icon: Target },
      { label: 'Quiz Milionário', path: '/v2/ia/quiz', icon: Star },
      { label: 'Quiz Live', path: '/v2/ia/quiz-live', icon: Zap },
      { label: 'Interclasse', path: '/v2/ia/interclasse', icon: Target },
      { label: 'Torneio', path: '/v2/ia/torneio', icon: Star },
    ],
    more: [
      { label: 'Quiz Live · Criar', path: '/v2/ia/quiz-live/criar', icon: Zap },
      { label: 'Quiz Live · Criar com IA', path: '/v2/ia/quiz-live/ai', icon: Sparkles },
      { label: 'Quiz Live · Relatórios', path: '/v2/ia/quiz-live/relatorios', icon: BarChart3 },
    ] },
  { id: 'growth', label: 'Growth', icon: Rocket, path: '/v2/growth', glow: '#F97316',
    children: [
      { label: 'Dashboard', path: '/v2/growth', icon: Rocket },
      { label: 'CRM Leads', path: '/v2/growth/crm', icon: Users },
      { label: 'Social AI', path: '/v2/growth/social', icon: Share2 },
      { label: 'Atendimento AI', path: '/v2/growth/atendimento', icon: MessageCircle },
      { label: 'Ads AI', path: '/v2/growth/ads', icon: Target },
      { label: 'Funnel AI', path: '/v2/growth/funnel', icon: TrendingUp },
      { label: 'WhatsApp AI', path: '/v2/growth/whatsapp', icon: MessageCircle },
      { label: 'Reputation AI', path: '/v2/growth/reputation', icon: Star },
    ],
    more: [
      { label: 'Growth Analytics', path: '/v2/growth/analytics', icon: BarChart3 },
    ] },
  { id: 'admin', label: 'Administração', icon: ShieldCheck, path: '/v2/configuracoes', glow: '#8E52AB',
    children: [
      { label: 'Equipe DNA', path: '/v2/configuracoes/equipe', icon: Users },
      { label: 'Usuários', path: '/v2/configuracoes/usuarios', icon: Shield, permV2: { module: 'usuarios', verb: 'visualizar' } },
      { label: 'Permissões V2', path: '/v2/permissoes-v2', icon: ShieldCheck, permV2: { module: 'permissoes', verb: 'visualizar' } },
      { label: 'Ponto', path: '/v2/configuracoes/ponto', icon: Clock },
      { label: 'Logs', path: '/v2/configuracoes/logs', icon: FileText },
      { label: 'Importar/Exportar', path: '/v2/configuracoes/importar', icon: Import },
      { label: 'Acervo Sponte', path: '/v2/acervo-sponte', icon: Archive, adminOnly: true },
    ] },
  { id: 'relatorios', label: 'Relatórios', icon: BarChart3, path: '/v2/relatorios', glow: '#8E52AB',
    children: [
      { label: 'Geral', path: '/v2/relatorios/geral', icon: FileText },
      { label: 'Consolidado', path: '/v2/relatorios/consolidado', icon: BarChart3 },
      { label: 'Expansão', path: '/v2/relatorios/expansao', icon: TrendingUp },
      { label: 'Custos', path: '/v2/relatorios/custos', icon: Wallet },
    ] },
  { id: 'sistema', label: 'Sistema', icon: Settings, path: '/v2/configuracoes/sistema', glow: '#64748B',
    children: [
      { label: 'Configurações', path: '/v2/configuracoes/sistema', icon: Settings },
      { label: 'Auditoria', path: '/v2/configuracoes/logs', icon: Shield },
    ] },
];

export const sectionCategories = {
  dashboard: ['executivo', 'relatorios', 'financeiro'],
  operacao: ['dnago'],
  alunos: ['pedagogico'],
  academico: ['pedagogico', 'dnacore'],
  financeiro: ['financeiro', 'fiscal', 'tributario', 'executivo'],
  comunicacao: ['marketing', 'administrativo', 'dnaconnect'],
  inteligencia: ['dna_ia'],
  growth: ['growth'],
  admin: ['administrativo'],
  relatorios: ['relatorios', 'estrategico'],
  sistema: ['administrativo'],
};

const FIN_SECTIONS = ['financeiro', 'fiscal', 'tributario', 'cobranca', 'festa_junina'];
const FIN_PATH = /\/v2\/(financeiro|dnapay|cobranca|fiscal|tributario|custos|folha)/i;

// Mesmos gates da sidebar desktop (permissões legadas + V2 + visibilidade financeira).
export function useAdminNav() {
  const { temAcessoCategoria, isAdmin, loading: permLoading } = usePermissoes();
  const { can: canV2, perms: permV2Data, financeiroVisivel } = usePermV2();
  return useMemo(() => {
    const finOk = (c) => financeiroVisivel || !FIN_PATH.test(c.path || '');
    const dropFinancial = (sections) => (financeiroVisivel ? sections : sections
      .filter((s) => !FIN_SECTIONS.includes(s.id))
      .map((s) => ({ ...s, children: (s.children || []).filter(finOk), more: (s.more || []).filter(finOk) }))
      .filter((s) => !s.children || s.children.length > 0 || !FIN_PATH.test(s.path || '')));
    const isPreview = typeof window !== 'undefined' && window.location.hostname.endsWith('.preview.emergentagent.com');
    const dropPreview = (sections) => (isPreview ? sections : sections.map((s) => ({ ...s, children: (s.children || []).filter((c) => !c.previewOnly) })));
    if (permLoading || isAdmin()) return dropPreview(dropFinancial(navSections));
    const gate = (children) => (children || []).filter((c) => {
      if (c.divider) return true;
      if (c.adminOnly || c.previewOnly) return false;
      if (!c.permV2) return true;
      if (permV2Data?.is_admin_bypass) return true;
      return canV2(c.permV2.module, c.permV2.verb);
    });
    return dropFinancial(navSections
      .map((section) => ({ ...section, children: gate(section.children), more: gate(section.more) }))
      .filter((section) => {
        if (section.children && section.children.length === 0) return false;
        const cats = sectionCategories[section.id];
        if (!cats) return true;
        return cats.some((cat) => temAcessoCategoria(cat));
      }));
  }, [temAcessoCategoria, isAdmin, permLoading, canV2, permV2Data, financeiroVisivel]);
}

export const normalizeText = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

// Sinônimos → trechos de rota. Só apontam para rotas existentes no catálogo.
const SYNONYMS = {
  boleto: ['/gerar-titulos', '/dnapay/titulos', '/importar-boletos', '/dnapay/remessas'],
  mensalidade: ['/dnapay/titulos', '/gerar-titulos', '/financeiro/planos'],
  cobranca: ['/inadimplentes', '/central-recuperacao', '/cobranca-extrajudicial', '/cobrancas-auto', '/renegociacao', '/cobranca-dashboard'],
  divida: ['/inadimplentes', '/central-recuperacao', '/cobranca-extrajudicial', '/renegociacao'],
  judicial: ['/central-recuperacao', '/cobranca-extrajudicial'],
  acordo: ['/renegociacao', '/central-recuperacao'],
  pix: ['/pix-extrato'],
  banco: ['/remessas', '/retornos', '/financeiro/contas', '/conciliacao'],
  cnab: ['/remessas', '/retornos'],
  pagamento: ['/dnapay/titulos', '/conciliacao', '/pix-extrato', '/retornos'],
  salario: ['/financeiro/folha'],
  imposto: ['/tributario', '/fiscal'],
  nfse: ['/fiscal'],
  'nota fiscal': ['/fiscal'],
  contrato: ['/dna-sign'],
  assinatura: ['/dna-sign'],
  nota: ['/academico/notas', '/academico/boletim', '/academico/pendencias'],
  prova: ['/academico/avaliacoes', '/editor-avaliacoes'],
  frequencia: ['/lista-chamada', '/livro-de-classe'],
  chamada: ['/lista-chamada', '/livro-de-classe'],
  falta: ['/lista-chamada', '/livro-de-classe'],
  horario: ['/academico/horarios'],
  grade: ['/academico/horarios', '/academico/matrizes'],
  aluno: ['/v2/aluno', '/cadastros-incompletos', '/carteirinhas'],
  estudante: ['/v2/aluno'],
  ficha: ['/v2/aluno'],
  responsavel: ['/v2/aluno', '/familia/admin'],
  familia: ['/v2/aluno', '/familia/admin'],
  pais: ['/v2/aluno', '/familia/admin'],
  matricula: ['/v2/matriculas'],
  rematricula: ['/v2/matriculas'],
  documento: ['/matriculas/documentos', '/academico/documentos', '/dna-sign'],
  declaracao: ['/academico/documentos', '/declaracao-ir'],
  comunicado: ['/comunicacao/mural', '/comunicacao/mensagens', '/comunicacao/campanhas'],
  aviso: ['/comunicacao/mural', '/comunicacao/mensagens'],
  mensagem: ['/comunicacao/mensagens', '/v2/chat'],
  whatsapp: ['/v2/chat', '/growth/whatsapp'],
  professor: ['/academico/professores', '/portal-professor'],
  funcionario: ['/configuracoes/equipe', '/configuracoes/ponto', '/financeiro/folha'],
  equipe: ['/configuracoes/equipe', '/portal-professor'],
  rh: ['/configuracoes/equipe', '/configuracoes/ponto', '/financeiro/folha'],
  acesso: ['/permissoes-v2', '/configuracoes/usuarios'],
  permissao: ['/permissoes-v2', '/configuracoes/usuarios'],
  senha: ['/configuracoes/usuarios'],
  usuario: ['/configuracoes/usuarios'],
  auditoria: ['/configuracoes/logs'],
  evento: ['/festa-junina', '/academico/calendario'],
  festa: ['/festa-junina'],
  ocorrencia: ['/operacao/ocorrencias'],
  saida: ['/operacao/painel', '/operacao/portaria', '/operacao/retiradas'],
  transporte: ['/operacao/vans'],
  historico: ['/secretaria/historico'],
  certificado: ['/secretaria/historico', '/academico/documentos'],
  turma: ['/academico/turmas', '/academico/agrupamentos'],
  sala: ['/academico/turmas'],
  calendario: ['/academico/calendario', '/academico/agenda'],
  lead: ['/growth/crm'],
  crm: ['/growth/crm'],
  despesa: ['/financeiro/despesas', '/financeiro/lancamentos'],
  caixa: ['/dre-caixa-ia', '/financeiro/lancamentos'],
  relatorio: ['/relatorios', '/financeiro/relatorios', '/lista-chamada', '/livro-de-classe'],
  impressao: ['/relatorio-impressao', '/festa-junina/imprimir'],
};

// Lista plana (sem duplicar rota) com seção e subgrupo, para busca/favoritos/recentes.
export function flattenNav(sections) {
  const seen = new Set();
  const out = [];
  sections.forEach((s) => {
    let group = '';
    [...(s.children || []), ...(s.more || []).map((m) => ({ ...m, extra: true }))].forEach((c) => {
      if (c.divider) { group = c.label; return; }
      if (seen.has(c.path)) return;
      seen.add(c.path);
      out.push({ ...c, sectionId: s.id, sectionLabel: s.label, group: c.extra ? 'Mais ferramentas' : group });
    });
  });
  return out;
}

export function searchTools(flat, query) {
  const q = normalizeText(query);
  if (!q) return [];
  const synPaths = Object.entries(SYNONYMS)
    .filter(([k]) => { const n = normalizeText(k); return n.startsWith(q) || (q.startsWith(n) && q.length - n.length <= 2); })
    .flatMap(([, v]) => v);
  const scored = flat.map((t) => {
    const label = normalizeText(t.label);
    const hay = `${label} ${normalizeText(t.sectionLabel)} ${normalizeText(t.group)} ${normalizeText(t.path.replace(/[/-]/g, ' '))}`;
    let score = 0;
    if (label.startsWith(q)) score = 4;
    else if (label.includes(q)) score = 3;
    else if (q.split(/\s+/).every((w) => hay.includes(w))) score = 2;
    if (!score && synPaths.some((p) => t.path.includes(p))) score = 1;
    return { t, score };
  }).filter((x) => x.score > 0);
  return scored.sort((a, b) => b.score - a.score).map((x) => x.t);
}

// Item do catálogo correspondente à rota atual (match exato ou prefixo mais longo).
export function matchTool(flat, pathname) {
  let best = null;
  flat.forEach((t) => {
    if (pathname === t.path || pathname.startsWith(`${t.path}/`)) {
      if (!best || t.path.length > best.path.length) best = t;
    }
  });
  return best;
}
